import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import { NbMediaBreakpointsService, NbThemeService } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import Quiz, { QuizAnswer } from "../../models/quiz.model";

@Component({
  selector: "ngx-view-quiz",
  styleUrls: ["./view-quiz.component.scss"],
  templateUrl: "./view-quiz.component.html",
})
export class ViewQuizComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() quiz: Quiz;
  loading = false;
  isMobile = false;

  constructor(
    private breakpointService: NbMediaBreakpointsService,
    private themeService: NbThemeService
  ) {}

  ngOnInit(): void {
    const { sm } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < sm),
        takeUntil(this.destroy$)
      )
      .subscribe((isLessThanSm: boolean) => {
        this.isMobile = isLessThanSm;
      });

    if (!this.quiz.question) {
      this.quiz.question = "";
    }
    if (!this.quiz.explain) {
      this.quiz.explain = "";
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectedAns(item: QuizAnswer) {
    if (this.quiz.type == "radio") {
      this.quiz.answers.forEach((element) => {
        if (element.value != item.value) {
          element.selected = false;
        }
      });
      this.quiz.selectedAnswers = [];
    }

    if (item.selected) {
      this.quiz.selectedAnswers.push(item.value);
    } else {
      const index = this.quiz.selectedAnswers.indexOf(item.value);
      if (index > -1) {
        this.quiz.selectedAnswers.splice(index, 1);
      }
    }
  }
}
